export const INIT_AUTH = 'auth/INIT_AUTH'
export const INIT_CONTACT_UNDERWRITERS = 'auth/INIT_CONTACT_UNDERWRITERS'
export const SET_AUTH = 'auth/SET_AUTH'
export const UNSET_AUTH = 'auth/UNSET_AUTH'

export const SET_LOADING = 'auth/SET_LOADING'
export const SET_AUTHENTICATED = 'auth/SET_AUTHENTICATED'
export const SET_USER = 'auth/SET_USER'
export const SET_CONTACT_UNDERWRITER = 'auth/SET_UNDERWRITER_CONTACT'
export const RESET_CONTACT_UNDERWRITER = 'auth/RESET_UNDERWRITER_CONTACT'

const createAction = type => payload => ({ type, payload })

export const initAuth = createAction(INIT_AUTH)
export const setAuth = createAction(SET_AUTH)
export const unsetAuth = createAction(UNSET_AUTH)

export const setLoading = createAction(SET_LOADING)
export const setAuthenticated = createAction(SET_AUTHENTICATED)
export const setUser = createAction(SET_USER)
export const initContactUnderwriters = createAction(INIT_CONTACT_UNDERWRITERS)
export const setContactUnderWriter = createAction(SET_CONTACT_UNDERWRITER)
export const resetContactUnderWriter = createAction(RESET_CONTACT_UNDERWRITER)
